import { useLocation } from 'react-router-dom';
import { PAGE_TITLES } from '@/constants/titles';

/**
 * Hook để lấy title của page hiện tại dựa trên route
 */
export function usePageTitle() {
  const location = useLocation();

  // Mapping từ pathname đến page title
  const getPageTitle = (pathname: string): string => {
    // Xử lý nested routes và exact matches
    if (pathname.startsWith('/stores')) {
      return PAGE_TITLES.STORES;
    }
    if (pathname.startsWith('/orders')) {
      return PAGE_TITLES.ORDERS;
    }
    if (pathname.startsWith('/roles')) {
      return PAGE_TITLES.ROLES;
    }
    if (pathname.startsWith('/departments')) {
      return PAGE_TITLES.DEPARTMENTS;
    }
    if (pathname.startsWith('/login')) {
      return PAGE_TITLES.LOGIN;
    }
    if (pathname.startsWith('/not-found')) {
      return PAGE_TITLES.NOT_FOUND;
    }

    // Exact matches
    switch (pathname) {
      case '/':
        return PAGE_TITLES.STORES;
      case '/stores':
        return PAGE_TITLES.STORES;
      case '/orders':
        return PAGE_TITLES.ORDERS;
      case '/roles':
        return PAGE_TITLES.ROLES;
      case '/departments':
        return PAGE_TITLES.DEPARTMENTS;
      case '/login':
        return PAGE_TITLES.LOGIN;
      case '/not-found':
        return PAGE_TITLES.NOT_FOUND;
      default:
        return '';
    }
  };

  return getPageTitle(location.pathname);
}
